import { Box, Checkbox, TableCell, TableRow, Typography } from '@mui/material';
import { paramCase } from 'change-case';
import { OrganizationManager } from 'src/careflow/ph-core/admin/organization/type/organization';
import Iconify from 'src/components/Iconify';
import { PATH_DASHBOARD } from 'src/routes/paths';
import CustomLink from 'src/careflow/common/CustomLink';
import crsAcls from 'src/careflow/ph-core/admin/permissions/util/crs/crsAcls';
import { checkAclValidation } from 'src/careflow/ph-core/admin/permissions/util/permission.utils';
import { NestedMenuItem } from 'mui-nested-menu';
import ActionButton from 'src/components/ActionButton';

type Props = {
  row: OrganizationManager;
  selected: boolean;
  editOption?: boolean;
  deleteOption?: boolean;
  customLink?: boolean;
  onEditRow: VoidFunction;
  onSelectRow?: VoidFunction;
  onDeleteRow: VoidFunction;
};

export default function OrganizationTableRow({
  row,
  selected,
  editOption,
  deleteOption,
  customLink,
  onEditRow,
  onSelectRow,
  onDeleteRow,
}: Props) {
  const { name, uuid } = row;

  const isAllowedToDelete = checkAclValidation({
    acls: [crsAcls.ADMIN.ORGANIZATIONS.DELETE],
  });

  const isAllowedToView = checkAclValidation({
    acls: [crsAcls.ADMIN.ORGANIZATIONS.VIEW],
  });

  const isAllowedAddChildOrg = checkAclValidation({
    acls: [crsAcls.ADMIN.ORGANIZATIONS.CHILD_ORGANIZATIONS.ADD],
  });

  return (
    <TableRow hover selected={selected}>
      {onSelectRow && (
        <TableCell padding="checkbox">
          <Checkbox 
            disabled={isAllowedAddChildOrg ? false : true} 
            checked={selected} 
            onClick={onSelectRow} 
          />
        </TableCell>
      )}
      <TableCell>
        {customLink ? (
          <CustomLink to={`${PATH_DASHBOARD.organization.edit(paramCase(uuid))}`}>
            <Typography noWrap variant="subtitle2">
              {name}
            </Typography>
          </CustomLink>
        ) : (
          <TableCell>
            <Typography variant="subtitle2" noWrap>
              {name}
            </Typography>
          </TableCell>
        )}
      </TableCell>
      <TableCell align="right">
        <ActionButton
          renderChildren={(isMenuOpen, setIsMenuOpen) => (
            <Box>
              {!deleteOption && isAllowedToDelete && (
                <NestedMenuItem
                  sx={{ paddingX: 3, color: 'error.main' }}
                  onClick={() => {
                    onDeleteRow();
                  }}
                  leftIcon={<Iconify icon="line-md:trash" width={20} height={20}/>}
                  rightIcon={null}
                  label="Delete"
                  parentMenuOpen={isMenuOpen}
                />
              )}
              {!editOption && isAllowedToView && (
                <NestedMenuItem
                  sx={{ paddingX: 3 }}
                  onClick={() => {
                    onEditRow();
                  }}
                  leftIcon={<Iconify icon={'eva:edit-fill'} width={20} height={20} />}
                  rightIcon={null}
                  label="Details"
                  parentMenuOpen={isMenuOpen}
                />
              )}
            </Box>
          )}
        />
      </TableCell>
    </TableRow>
  );
}
